
import { ALL_CANDI_REQUEST_REQUEST, ALL_CANDI_REQUEST_SUCCESS, ALL_CANDI_REQUEST_FAIL } from "../constants/AuthConstant"

const axios = require("axios");
export const AllCandidateL = (data) => {
  return function (dispatch) {
    dispatch({
      type: ALL_CANDI_REQUEST_REQUEST,
      payload: true,
    });
    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/get_all_candidate?vendorId=${data.vendorId}&pageNumber=${data.pageNumber}&pageSize=10&search=${data.search}&skills=${data.encodedData}&city=${data.citySendApi}&currentDesignations=${data.designationSendapi}&minExperience=${data.min}&maxExperience=${data.max}`,
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    };
    axios(OPTION)
      .then((res) => {
        dispatch(loadAllDetailsPre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: ALL_CANDI_REQUEST_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
      });
  };
};
export const loadAllDetailsPre = (data) => {
  return {
    type: ALL_CANDI_REQUEST_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};
